import { FeesField } from '../../IAppModels';

export const FeesRadioInput = ({ fieldName, fieldLabel, data, updateData }: FeesField) => {
  return (
    <div className='form-check form-check-custom form-check-solid'>
      <input
        className='form-check-input me-2'
        type='radio'
        id={fieldLabel}
        name='role'
        defaultChecked={data.pricingSetup.creditType === fieldName}
        onChange={() => {
          updateData({
            pricingSetup: {
              ...data.pricingSetup,
              creditType: fieldName,
            },
          })
        }}
      />
      <label className='form-check-label' htmlFor={fieldLabel}>
        <div className='fs-5'>{fieldLabel}</div>
      </label>
    </div>)
}